export default {
  PWmodule: {
    banner: 'Introduction',
    bannerP1: `
         Based on the basic functions of PWmat, we have developed some top-level modules (MODULEs) to meet
         the needs of users. Some of these MODULEs are interfaces with existing excellent tools,
         some are based on the calculation results of PWmat to obtain the actual physical quantities required,
         and some are calculation processes designed for specific calculation needs.
         These MODULEs cover material structure, basic properties, calculations for large systems,
         and machine learning force fields. They are comprehensive and easy to operate.
         Users are welcome to download and use them. For details, please see
    `,
    bannerP1_1: 'the instruction document',
    bannerP1_2: ', which contains links to all MODULEs.',
    menu1: 'Material structure',
    menu1_1: 'Structural Search',
    menu1_2: 'Disordered structure',
    menu1_3: 'Molecular Dynamics Data Processing',
    menu1_4: 'CIF file conversion and structure processing',
    menu2: 'Electronic structure and phonon calculations',
    menu2_1: 'Electronic structure',
    menu2_2: 'Phonon calculations',
    menu3: 'Optical, magnetic, mechanical and polarization properties',
    menu3_1: 'Optical properties',
    menu3_2: 'Magnetic properties',
    menu3_3: 'Mechanical properties',
    menu3_4: 'Polarization properties',
    menu4: 'Nature of defect',
    menu5: 'Electrochemical properties',
    menu6: 'Transport properties',
    menu7: 'Ultrafast kinetics',
    menu9: 'Electron beam irradiation',
    menu10: 'Large system computing',
    menu11: 'Machine Learning Force Field',
    menu12: 'all',
    tabletitle: 'Using the Module',
    tableC1: 'name',
    tableC2: 'Introduction',
    tabletxt1: 'Tutorial',
    tabletxt2: 'File download',
    tabletxt3: 'Example',
  },
}